import About from '@/views/About/About'
export default {
  name: 'About',
  mixins: [About]
}
